import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class RoleService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    createRole(role: any) {
        return this.http.post(this.BaseURI + '/Role', role);
    }

    getListRole() {
        return this.http.get(this.BaseURI + '/Role');
    }

    updateRole(role: any) {
        return this.http.put(this.BaseURI + '/Role', role);
    }

    deleteRole(id: any) {
        return this.http.delete(this.BaseURI + '/Role/' + id);
    }
}